import { Injectable } from '@angular/core';
import { VehiclePickdropListService } from '../data-services/vehicle-pickdrop-list.service';
import { GenericResponse } from '../business-entities/generic-response';
import { VehiclePickupDrop } from '../business-entities/vehicle-pickup-drop';

@Injectable({
  providedIn: 'root'
})
export class VehiclePickDropListService {
  dealerId:string = '';
  filterTypeId: number = 0;
  VehiclePickDropList : VehiclePickupDrop[];

  constructor(private service : VehiclePickdropListService) { }

  async getVehiclePickDropList(data):Promise<any>{
    await this.service.getVehiclePickDropList(data).then(
      (res:GenericResponse<Array<VehiclePickupDrop>>)=>{
        this.VehiclePickDropList = res.responseObject;
      }
    );
    return this.VehiclePickDropList;
  }
  
}
